// Does this user's TENANT get the Insights (Overview) screen? A Descope tenant
// custom attribute (`insightsEnabled`) exposed as a custom claim, so it rides in
// the session token — the same mechanism as `allowedModels` next door: no endpoint,
// no table, nothing to keep in sync, and already signed.
//
// ⚠ A product gate, NOT access control. `GET /api/insights` still answers whoever
// asks, and does not need guarding — the answer is that tenant's own data. What
// this decides is whether signing in LANDS on Overview and whether the nav offers
// it. Whether cards get WRITTEN at all is a separate, environment-level gate
// (`insights_agent_id`, empty in the server's prod config), which is why this one
// can be per-tenant without also being a spend control.
//
// Read from the token, so it changes only when the token does: flipping the
// attribute in the console does nothing for a session that is already open until
// it refreshes.

/**
 * True only for an explicit true. Everything else — missing, empty, malformed, or a
 * tenant that predates the attribute — is OFF, so a tenant nobody has switched on
 * keeps opening to the chat canvas it has always opened to. That default is what
 * makes this safe to ship to every environment at once.
 *
 * Accepts a real boolean or the string `"true"`: the value is set by hand per tenant
 * in the Descope console, and `allowedModels` next door is proof that hand-set
 * attributes do not always reach the token in the type you expect. Anything else,
 * `1` included, stays off — a gate should not open on a guess.
 */
export function parseInsightsEnabled(claims: unknown): boolean {
  const c = (claims ?? {}) as Record<string, unknown>;
  const ns = (c.nsCustomClaims ?? {}) as Record<string, unknown>;
  const raw = c.insightsEnabled ?? ns.insightsEnabled;
  return raw === true || String(raw).trim().toLowerCase() === 'true';
}
